export default {
  state: {
    // 投放渠道
    xnhQudao: "",
    qdAccount: "",  // 渠道账号
    qdPwd: "",  // 渠道密码
    qdCompany: "",  // 渠道集团名
    qdCompanyUid: "",  // 渠道集团uid
    sdkTraceId: ""  // Amber SDK 生成的会话追踪ID，单次会话全程固定
  },
  getters: {

  },
  mutations: {
    setQudao(state, value) {
      state.xnhQudao = value;
    },
    setQdAccount(state, value) {
      state.qdAccount = value;
    },
    setQdPwd(state, value) {
      state.qdPwd = value;
    },
    setQdCompany(state, value) {
      state.qdCompany = value;
    },
    setQdCompanyUid(state, value) {
      state.qdCompanyUid = value;
    },
    setSdkTraceId(state, value) {
      // 只在第一次设置时生效，确保会话期间不变
      if (!state.sdkTraceId) {
        state.sdkTraceId = value;
      }
    }
  },
  actions: {

  }
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js